(function () {
  'use strict';

  // Click outside desktop mega menu to close
  document.addEventListener('click', function (event) {
    document.querySelectorAll('header-menu details[open].mega-menu--products').forEach(function (d) {
      if (!d.contains(event.target)) {
        d.removeAttribute('open');
        const s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Escape to close
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('header-menu details[open].mega-menu--products').forEach(function (d) {
      d.removeAttribute('open');
      const s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
    // Also close opened mobile categories
    document.querySelectorAll('details.menu-drawer__category[open]').forEach(function (d) {
      d.removeAttribute('open');
    });
  });

  // Mobile drawer body class
  function observeDrawer() {
    const drawer = document.getElementById('Details-menu-drawer-container');
    if (!drawer) return;
    const update = function () {
      document.body.classList.toggle('menu-drawer-open', drawer.hasAttribute('open'));
    };
    new MutationObserver(update).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    update();
  }

  // Desktop tab switching
  function initCategoryTabs() {
    document.querySelectorAll('[data-mega-menu]').forEach(function (container) {
      const tabs = container.querySelectorAll('[data-mega-tab]');
      const panels = container.querySelectorAll('[data-mega-panel]');

      function activate(key) {
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-mega-tab') === key);
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === key);
        });
      }

      tabs.forEach(function (tab) {
        const key = tab.getAttribute('data-mega-tab');
        tab.addEventListener('mouseenter', function () { activate(key); });
        tab.addEventListener('focus', function () { activate(key); });
      });
    });
  }

  // Close button in mobile drawer
  function initDrawerCloseButton() {
    document.addEventListener('click', function (event) {
      const closeBtn = event.target.closest('[data-menu-drawer-close]');
      if (!closeBtn) return;
      event.preventDefault();
      const drawer = document.getElementById('Details-menu-drawer-container');
      if (drawer) drawer.removeAttribute('open');
      // Also close any opened category
      document.querySelectorAll('details.menu-drawer__category[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
      // FIX: clean up submenu-open classes that hide main navigation
      // Zonder deze cleanup blijft .menu-drawer__navigation visibility: hidden bij heropen
      document.querySelectorAll('.submenu-open').forEach(function (el) {
        el.classList.remove('submenu-open');
      });
      document.querySelectorAll('details.menu-opening').forEach(function (d) {
        d.classList.remove('menu-opening');
      });
    });
  }

  // Back button in submenu (closes only the category, not the drawer)
  function initSubmenuBackButton() {
    document.addEventListener('click', function (event) {
      const backBtn = event.target.closest('[data-submenu-back]');
      if (!backBtn) return;
      event.preventDefault();
      const parentDetails = backBtn.closest('details.menu-drawer__category');
      if (parentDetails) parentDetails.removeAttribute('open');
      // FIX: ook submenu-open class weghalen zodat main nav weer zichtbaar is
      document.querySelectorAll('.submenu-open').forEach(function (el) {
        el.classList.remove('submenu-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeDrawer();
      initCategoryTabs();
      initDrawerCloseButton();
      initSubmenuBackButton();
    });
  } else {
    observeDrawer();
    initCategoryTabs();
    initDrawerCloseButton();
    initSubmenuBackButton();
  }
})();